export default "__VITE_ASSET__DVvFqu$r__"